/**
 * API configuration constants
 */
export const API_BASE_URL = 'http://localhost:8080/api';
